import React, { useContext, useState } from 'react';
import { HomeContext } from "../home/Home"
import { Stack } from '@mui/system';
import InvoiceTable from './components/InvoiceTable';
import CostTable from './components/CostTable';
import { Button, Snackbar, styled } from '@mui/material';
import { CopyAll } from '@mui/icons-material';


const StyledStack = styled(Stack)({
  display: "flex",
  alignItems: "end",
});

const StyledButton = styled(Button)({
  maxWidth: 100,
});

const Invoice = () => {

  const [open, setOpen] = useState(false);
  function copyTable(id) {
    const elTable = document.getElementById(id);
    let range, sel;

    // Ensure that range and selection are supported by the browsers
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      // unselect any element in the page
      sel.removeAllRanges();
      try {
        range.selectNodeContents(elTable);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(elTable);
        sel.addRange(range);
      }
      document.execCommand("Copy");
    }
    sel.removeAllRanges();
    setOpen(true);
  }
  const { equipments, features, options, installs, oneTime } = useContext(HomeContext);
  const invoiceSection = [
    { isHeader: true, title: "Features Included", subtitle: "Value" }, ...features,
    { isHeader: true, title: "Installation and Peripherals", subtitle: "Value" }, ...installs,
  ];

  return (
    <Stack sx={{ margin: "16px" }} spacing="24px">
      <StyledStack spacing="8px">
        <Button variant="outlined" size="small" endIcon={<CopyAll />} onClick={() => copyTable("inovice-table")}>COPY</Button>
        <div id="inovice-table" style={{ width: "100%" }}><InvoiceTable section={invoiceSection} /></div>
      </StyledStack>
      <StyledStack spacing="8px">
        <StyledButton variant="outlined" size="small" endIcon={<CopyAll />} onClick={() => copyTable("equipment-table")}>COPY</StyledButton>
        <div id="equipment-table" style={{ width: "100%" }}><CostTable title={"Equipment"} section={equipments} color={"teal"} /></div>
      </StyledStack>
      <StyledStack spacing="8px">
        <StyledButton variant="outlined" size="small" endIcon={<CopyAll />} onClick={() => copyTable("recurring-table")}>COPY</StyledButton>
        <div id="recurring-table" style={{ width: "100%" }}><CostTable title={"Recurring Charges"} section={options} color={"darkslategray"} /></div>
      </StyledStack>
      <StyledStack spacing="8px">
        <StyledButton variant="outlined" size="small" endIcon={<CopyAll />} onClick={() => copyTable("one-time-table")}>COPY</StyledButton>
        <div id="one-time-table" style={{ width: "100%" }}><CostTable title={"One-Time Charges"} section={oneTime} color={"seagreen"} /></div>
      </StyledStack>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        onClose={() => setOpen(false)}
        autoHideDuration={1000}
        message="Copied to clipboard!"
        ContentProps={{ sx: { borderRadius: 230 } }}
      />
    </Stack>
  );
}

export default Invoice